"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkProvider = exports.useLink = void 0;
const react_1 = __importDefault(require("react"));
const defaultContext = {
    routeTo: null,
};
const LinkContext = react_1.default.createContext(defaultContext);
exports.useLink = () => react_1.default.useContext(LinkContext);
/**
 * React context that provides the `routeTo` function to `Link`
 * components to be able to do client side routing when needed
 */
exports.LinkProvider = ({ children, routeTo }) => {
    return children ? (react_1.default.createElement(LinkContext.Provider, { value: { routeTo } }, react_1.default.Children.only(children))) : null;
};
